import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";

const AcceptableUsePolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button className="policy-back-btn" onClick={() => navigate(-1)} type="button">
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Acceptable Use Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Purpose</h2>
          <p>
            This policy outlines acceptable and prohibited use of Kairos. You agree to follow
            this policy when using our website builder, AI features, publishing tools, and services.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Prohibited activities</h2>
          <ul>
            <li>Illegal activity, fraud, or impersonation.</li>
            <li>Uploading malware, ransomware, spyware, or harmful code.</li>
            <li>Phishing, scams, deceptive practices, or social engineering.</li>
            <li>Harassment, hate, threats, or incitement to violence.</li>
            <li>Creating or hosting content that infringes intellectual property rights.</li>
            <li>Attempting unauthorized access to accounts, systems, or data.</li>
            <li>Abuse of APIs, automation, scraping, or excessive requests that harm stability.</li>
            <li>Using the platform to distribute spam or unsolicited marketing.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. AI-specific usage</h2>
          <ul>
            <li>Do not use Kairos AI to generate content that promotes illegal activity or fraud.</li>
            <li>Do not attempt to bypass safeguards, jailbreak, or exploit the service.</li>
            <li>
              You are responsible for reviewing AI outputs before publishing (accuracy, legality, and compliance).
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Publishing and user content</h2>
          <ul>
            <li>You must have rights to publish all content you upload or generate.</li>
            <li>We may remove or restrict content that violates this policy or applicable law.</li>
            <li>You are responsible for your customers’ data handling when you collect data on your sites.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Enforcement</h2>
          <p>
            Violations may result in content removal, feature restrictions, account suspension, or termination.
            We may also cooperate with law enforcement if required.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Reporting abuse</h2>
          <p>
            If you believe someone is violating this policy, contact <strong>support@yourdomain.com</strong>.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Updates</h2>
          <p>
            We may update this Acceptable Use Policy. The “Last updated” date will reflect changes.
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default AcceptableUsePolicy;
